module.exports = __webpack_public_path__ + "static/work40-56fbe85eb03f347eef465a8273a7d37a.jpg";